













import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import MainButton from '@/main-components/common/MainButton.vue';

@Component({
  components: {
    Modal,
    MainButton,
  },
})
export default class ModalGradePaperPicture extends Vue {
  @Prop({ required: true })
  image: string;

  openModal: any = null;
  closeModal: any = null;

  mounted() {
    this.$emit('openModalGradePaperPictureAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }
}
